import React from "react"
import "./clockIcon.scss";




const ClockIcon = (props: {className: string, animate: boolean}) => {
    const animateClass = props.animate ? 'animateIcon' : ''
    return (
        <svg version="1.1" id="clockircle" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            viewBox="0 0 512 512" className={`icon ${animateClass} ${props.className}`}>
        <circle fill="none" stroke="#231F20" strokeWidth="13" strokeMiterlimit="10" cx="256" cy="256" r="245.75"/>
        <polyline fill="none" stroke="#231F20" strokeWidth="13" strokeMiterlimit="10" points="255.04,119.34 255.04,256 388.41,370.61"/>
        </svg>

    )
}

export default ClockIcon
